<template>
  <div class="page-turner">
    <div
      class="page-turner-header"
      :class="{ 'is-modal': isModal }"
    >
      <div class="page-turner-header-nav">
        <slot name="title" />
        <v-btn
          icon
          size="small"
          class="ml-4"
          elevation="0"
          :disabled="disableNext || isAnimating"
          @click="handlePrevPage"
        >
          <v-icon icon="$chevron-left" />
        </v-btn>
        <v-btn
          icon
          size="small"
          class="ml-4"
          elevation="0"
          :disabled="disablePrevious || isAnimating"
          @click="handleNextPage"
        >
          <v-icon icon="$chevron-right" />
        </v-btn>
      </div>
      <CloseIcon
        v-if="closeIcon"
        type="button"
        class="page-turner-header-close"
        @click="$emit('close')"
      />
    </div>
    <div
      class="page-turner"
      :class="{
        'prev-animate': prevPageAnimation,
        'next-animate': nextPageAnimation,
        'final-next-animate': finalNextAnimation,
        'final-prev-animate': finalPrevAnimation,
      }"
    >
      <slot name="pagedContent" />
    </div>
  </div>
</template>

<script>
import CloseIcon from '@/assets/icon-close.svg?component';

export default {
  name: 'PageTurner',
  components: {
    CloseIcon,
  },
  props: {
    page: { type: Number, default: 1 },
    totalPages: { type: Number, default: 1 },
    reversePages: { type: Boolean, default: false },
    pageEnds: { type: Object, default() { return null; } },
    closeIcon: { type: Boolean, default: false },
    isModal: { type: Boolean, default: false },
  },
  emits: ['nextPage', 'prevPage', 'close'],
  data() {
    return {
      nextPageAnimation: false,
      prevPageAnimation: false,
      finalNextAnimation: false,
      finalPrevAnimation: false,
      sliderDirection: 'next',
    };
  },
  computed: {
    isAnimating() {
      return this.nextPageAnimation
        || this.prevPageAnimation
        || this.finalNextAnimation
        || this.finalPrevAnimation;
    },
    disablePrevious() {
      if (this.reversePages) {
        if (this.pageEnds?.end) {
          return this.page === this.pageEnds.end;
        }
        return this.page === this.totalPages;
      }

      if (this.pageEnds?.start) {
        return this.page === this.pageEnds.start;
      }

      return this.page === 1;
    },
    disableNext() {
      if (this.reversePages) {
        if (this.pageEnds?.start) {
          return this.page === this.pageEnds.start;
        }
        return this.page === 1;
      }

      if (this.pageEnds?.end) {
        return this.page === this.pageEnds.end;
      }

      return this.page === this.totalPages;
    },
  },
  methods: {
    handleNextPage() {
      this.sliderDirection = 'next';
      this.nextPageAnimation = true;
      setTimeout(() => {
        this.$emit('nextPage');
        this.nextPageAnimation = false;
        this.finalNextAnimation = true;
        setTimeout(() => {
          this.finalNextAnimation = false;
        }, 250);
      }, 250);
    },
    handlePrevPage() {
      this.sliderDirection = 'prev';
      this.prevPageAnimation = true;
      setTimeout(() => {
        this.$emit('prevPage');
        this.prevPageAnimation = false;
        this.finalPrevAnimation = true;
        setTimeout(() => {
          this.finalPrevAnimation = false;
        }, 250);
      }, 250);
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes prev {
  from { transform: translateX(0px); opacity: 1; }
  to { transform: translateX(-100%); opacity: 0; }
}

@keyframes next {
  from { transform: translateX(0px); opacity: 1; }
  to { transform: translateX(100%); opacity: 0; }
}

@keyframes finalNext {
  from { transform: translateX(-100%); opacity: 0; }
  to { transform: translateX(0px); opacity: 1; }
}

@keyframes finalPrev {
  from { transform: translateX(100%); opacity: 0; }
  to { transform: translateX(0px); opacity: 1; }
}
.page-turner {
  flex: 1 1 0px;
  height: 100%;
  border-radius: 10px;
  &.next-animate {
    animation-name: prev;
    animation-duration: .25s;
    animation-timing-function: ease-in-out;
  }
  &.prev-animate {
    animation-name: next;
    animation-duration: .25s;
    animation-timing-function: ease-in-out;
  }
  &.final-next-animate {
    animation-name: finalPrev;
    animation-duration: .25s;
    animation-timing-function: ease-in-out;
  }
  &.final-prev-animate {
    animation-name: finalNext;
    animation-duration: .25s;
    animation-timing-function: ease-in-out;
  }
}
.page-turner-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.is-modal {
  background: @white;
  border-bottom: 1px solid @stroke-default;
  padding: 18px 24px;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 3;

}
.page-turner-header-nav {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.page-turner-header-close {
  cursor: pointer;
  color: @grey-500;
}
.v-btn {
  background: @bg-canvas;
  height: 32px;
  width: 32px;
  user-select: none;
}
</style>
